import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import getContent from 'pp-react-l10n';
import { renderSwitchComponent } from '../../switchPanels/SwitchPanel';
import TemplateData from '../../../../utility/getTemplateData';

const getMailingAddrContent = getContent('locals')('buttonsV3/mailingAddress');
const title = getMailingAddrContent('title');
const countryAndLocale = {
  country: TemplateData.country,
  locale: `${TemplateData.language}_${TemplateData.country}`,
};
const mailingAddrSubTitle = getMailingAddrContent(
  'subTitle',
  countryAndLocale,
  { useHTML: true }
);

function MailingAddressSwitch({ isChecked }) {
  return (
    <Field
      id="getMailingAddress"
      name="noShipping"
      label="getMailingAddress"
      title={title}
      subTitle={mailingAddrSubTitle}
      component={renderSwitchComponent}
      isChecked={isChecked}
      reversed={true}
      noDivider={true}
    />
  );
}

MailingAddressSwitch.propTypes = {
  isChecked: PropTypes.bool,
};

export default MailingAddressSwitch;
